<template>
  <hr class="sf-divider" />
</template>
<script>
export default {
  name: "SfDivider",
};
</script>
<style lang="scss">
@import "~@storefront-ui/shared/styles/components/atoms/SfDivider.scss";
</style>
